import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// The prerendered HTML carries this route's JSON-LD for crawlers that never run this bundle. Once
// React is running, each page sets its own schema, so the build-time copies are removed to avoid a
// duplicate pair and, after client-side navigation, a stale one.
document
  .querySelectorAll('script[type="application/ld+json"][data-prerender]')
  .forEach((node) => node.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
